import Navbar from "../navbar/Navbar";
import Header from "../header/Header";
import Products from "../products/products";
import Footer from "../footer/Footer";
import { Features } from "../features/Features";

const Home = () => {
  return (
    <div className="home mt-16">
      <Navbar />
      <Header />
      <Features />
      <Products />
      <Footer />
    </div>
  );
};

export default Home;
